import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/schedule',
  title: window.language['menu.program.publish'],
  component: dynamicWrapper(app, [
    import('./model'),
    import('../../HomePage/model'), 
    import('../../System/Org/model'), 
    import('../../System/SysConfig/model'),
    import('../../Material/Material/model'), 
    import('../../Material/Folder/model'), 
    import('../Playlist/model'), 
  ], () => import('./components'))
});

export default app => createRoute(app, routesConfig);


// WEBPACK FOOTER //
// ./src/routes/Program/Schedule/index.js